module.exports = __webpack_public_path__ + "img/exam3.7975e067.png";